module.exports = __webpack_public_path__ + "img/goodsB2.9492430a.png";